module.exports = __webpack_public_path__ + "img/bg-matching2.9a0ecd6b.png";